export default {
    en: {
        messages: {
            required: (field) => `The ${field} field is required.`,
            numeric: (field) => `Please enter a valid ${field}.`,
            max_value: () => 'Value exceeds the field limit.',
        },
    },
};
